// extracted by mini-css-extract-plugin
export var anchor = "_4k-0";
export var discard = "_4k-4";
export var muiTooltipTooltip = "_4k-6";
export var notificationBar = "_4k-3";
export var saveButtonHoverSlotWrapper = "_4k-5";
export var show = "_4k-2";
export var spacer = "_4k-1";